module.exports = __webpack_public_path__ + "img/nobu_logo-white.9c47d45a.svg";